/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { I18n } from "@aws-amplify/core";
import AmplifyRequireNewPassword from "aws-amplify-react/lib/Auth/RequireNewPassword";
import { AuthShell, withInlineAuthError } from "./AuthFormShared";
import { RequireNewPasswordFormView } from "./AuthFormViews";

const RequireNewPasswordBase: any = withInlineAuthError(
    AmplifyRequireNewPassword,
);

export class RequireNewPassword extends RequireNewPasswordBase {
    showComponent() {
        const { hide, authData } = this.props;
        if (hide && hide.includes(RequireNewPassword)) {
            return null;
        }

        const requiredAttributes: string[] =
            authData?.challengeParam?.requiredAttributes ?? [];

        return (
            <AuthShell title={I18n.get("Change Password")}>
                <RequireNewPasswordFormView
                    error={this.state.authError}
                    onBackToSignIn={() => this.changeState("signIn")}
                    onFieldChange={this.handleInputChange}
                    onSubmit={event => {
                        event.preventDefault();
                        this.change();
                    }}
                    requiredAttributes={requiredAttributes}
                />
            </AuthShell>
        );
    }
}

export default RequireNewPassword;
